import { render } from "./MultiselectOption.vue?vue&type=template&id=0c6d9e57&ts=true"
import script from "./MultiselectOption.vue?vue&type=script&lang=ts"
export * from "./MultiselectOption.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__